import { ViewportBreakpoint } from '#/theme/theme';
import { getViewportBreakpoint } from '#/utils/viewport/getViewportBreakpoint';

function getIsDesktop() {
  const breakpoint = getViewportBreakpoint();
  return (
    breakpoint === ViewportBreakpoint.md || breakpoint === ViewportBreakpoint.lg
  );
}

let localIsDesktop: boolean | undefined;

export function isDesktop() {
  if (typeof localIsDesktop !== 'boolean') {
    localIsDesktop = getIsDesktop();

    window.addEventListener('resize', () => {
      localIsDesktop = getIsDesktop();
    });
  }

  return localIsDesktop;
}
